import { getLanguage } from './func';

// Carry only the public event heading while the original opinion is fetched.
// Keep author/comment data out of history and never reuse another card/language.
export function createFeedStoryPreview(reactionId, story, refreshKey = null) {
  const id = Number(reactionId);
  const storyId = Number(story?.id);
  if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(storyId) || storyId <= 0
    || typeof story?.title !== 'string' || !story.title.trim()) return null;
  return { reactionId: id, language: getLanguage(), refreshKey, story: { id: storyId, title: story.title } };
}

export function readFeedStoryPreview(state, reactionId) {
  const preview = state?.feedStoryPreview;
  if (!preview || preview.language !== getLanguage() || preview.reactionId !== Number(reactionId)
    || preview.refreshKey !== (state.feedRefresh ?? null)) return null;
  return createFeedStoryPreview(reactionId, preview.story)?.story || null;
}
